export default __webpack_public_path__ + "img/evXZXIPn.7e642a30.svg";